import { ReactNode, memo } from "react";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
import DropDownItem from "types/dropDownItem";
import {
  DarkDropdownMenu,
  DarkDropdownItem,
} from "components/shared/DarkDropdownStyles";

interface DropDownButtonProps {
  children: ReactNode;
  dropDownItems: Array<DropDownItem>;
  drop?: "up" | "down" | "start" | "end";
}

const StyledDropDownToggle = styled(Dropdown.Toggle)`
  background-color: #21b400 !important;
  border-color: #21b400 !important;
  text-transform: uppercase;

  &:focus,
  &:active,
  &:disabled,
  &:hover {
    border-color: #21b400 !important;
    background-color: #21b400 !important;
  }

  &:after {
    margin-left: 8px !important;
  }
`;

const DropDownButton = (props: DropDownButtonProps) => {
  const { children, dropDownItems, drop = "down" } = props;

  return (
    <Dropdown drop={drop}>
      <StyledDropDownToggle variant="success">{children}</StyledDropDownToggle>

      <DarkDropdownMenu>
        {dropDownItems.map((value: DropDownItem, index: number) => {
          return (
            <DarkDropdownItem key={index} target="_blank" href={value.url}>
              {value.title}
            </DarkDropdownItem>
          );
        })}
      </DarkDropdownMenu>
    </Dropdown>
  );
};

export default memo(DropDownButton);
